exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.content[data-v-2368acde]{padding:0 !important\n}\n.wallet-iframe-wrap[data-v-2368acde]{width:100%;height:calc(100vh - 53px - 40px)\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shop/src/pages/purseSetting/record/index.vue"],"names":[],"mappings":";AAgCA,0BACE,oBAAqB;CACtB;AAAA,qCAEC,WACA,gCAAiC;CAClC","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.content {\n  padding: 0 !important;\n}\n.wallet-iframe-wrap {\n  width: 100%;\n  height: calc(100vh - 53px - 40px);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2368acde","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/purseSetting/record/index.vue
// module id = uqJn
// module chunks = 2